import { BlockType, BooleanFieldSchema, FieldGroupSchema, PasswordInputFieldSchema } from './Types';
import { z } from 'zod';

export const PasswordFieldSchema = PasswordInputFieldSchema.extend({
  name: z.literal('password'),
});
export type PasswordField = z.infer<typeof PasswordFieldSchema>;

export const EnabledFieldSchema = BooleanFieldSchema.extend({
  name: z.literal('enabled'),
});
export type EnabledField = z.infer<typeof EnabledFieldSchema>;

export const PagePasswordFieldSchema = z.discriminatedUnion('name', [PasswordFieldSchema, EnabledFieldSchema]);

export const PagePasswordFieldGroupSchema = FieldGroupSchema.extend({
  fields: z.array(PagePasswordFieldSchema),
});
export type PagePasswordFieldGroup = z.infer<typeof PagePasswordFieldGroupSchema>;

// Block config schema and type
export const PagePasswordBlockConfigSchema = z.object({
  options: z.record(z.any()),
  type: z.literal(BlockType.PagePassword),
  fieldGroups: z.tuple([PagePasswordFieldGroupSchema]),
  version: z.literal(2),
});

export type PagePasswordBlockConfig = z.infer<typeof PagePasswordBlockConfigSchema>;
